import React from 'react';
import { SEO } from '../components/SEO';
import { PersonalHero } from '../components/PersonalHero';
import { StatsBar } from '../components/StatsBar';
import { StorySection } from '../components/StorySection';
import { JourneyTimeline } from '../components/JourneyTimeline';
import { UniqueValue } from '../components/UniqueValue';
import { ResultsSection } from '../components/ResultsSection';
import { PhilosophySection } from '../components/PhilosophySection';
import { FinalCTA } from '../components/FinalCTA';
export function HomePage() {
  return <>
      <SEO title="Justus Kraft - CRM Experte | Vertriebs-Automatisierung" description="Mit 16 Jahren mein erstes Gewerbe gegründet. Heute, mit 23 Jahren, helfe ich Unternehmen, ihren Vertrieb durch intelligente CRM-Systeme zu verdoppeln. 110+ zufriedene Kunden, DSGVO-konform." keywords="CRM Experte, Vertriebsautomatisierung, CRM Beratung, Justus Kraft, CRM Kraft, B2B Vertrieb, B2C Vertrieb, CRM Systeme, Vertriebsoptimierung" data-id="element-422" />
      <main data-id="element-423">
        <PersonalHero data-id="element-424" />
        <StatsBar data-id="element-425" />
        <StorySection data-id="element-426" />
        <JourneyTimeline data-id="element-427" />
        <UniqueValue data-id="element-428" />
        <ResultsSection data-id="element-429" />
        <PhilosophySection data-id="element-430" />
        <FinalCTA data-id="element-431" />
      </main>
    </>;
}